import PropTypes from 'prop-types'
import hasPermission from '../../utils/helpers/hasPermission'

// Renders its children only when the server allows `permission` in the selected org (or in
// any of `orgIds`); with `orgWide`, only when it allows it on the org as a whole (see hasPermission).
const IsPermitted = ({ permission, orgIds, orgWide, children }) => {
  if (!children) return null

  return hasPermission(permission, orgIds, { orgWide }) ? children : null
}

IsPermitted.propTypes = {
  permission: PropTypes.string.isRequired,
  orgIds: PropTypes.arrayOf(PropTypes.string),
  orgWide: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default IsPermitted
